var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.7008C1.45 20.7008 0.979 20.5048 0.587 20.1128C0.195667 19.7214 0 19.2508 0 18.7008V4.70078C0 4.15078 0.195667 3.67978 0.587 3.28778C0.979 2.89645 1.45 2.70078 2 2.70078H10.925L8.925 4.70078H2V18.7008H16V11.7508L18 9.75078V18.7008C18 19.2508 17.8043 19.7214 17.413 20.1128C17.021 20.5048 16.55 20.7008 16 20.7008H2ZM13.175 3.27578L14.6 4.67578L8 11.2758V12.7008H9.4L16.025 6.07578L17.45 7.47578L10.825 14.1008C10.6417 14.2841 10.4293 14.4301 10.188 14.5388C9.946 14.6468 9.69167 14.7008 9.425 14.7008H7C6.71667 14.7008 6.47933 14.6051 6.288 14.4138C6.096 14.2218 6 13.9841 6 13.7008V11.2758C6 11.0091 6.05 10.7548 6.15 10.5128C6.25 10.2714 6.39167 10.0591 6.575 9.87578L13.175 3.27578ZM17.45 7.47578L13.175 3.27578L15.675 0.775781C16.075 0.375781 16.5543 0.175781 17.113 0.175781C17.671 0.175781 18.1417 0.375781 18.525 0.775781L19.925 2.20078C20.3083 2.58411 20.5 3.05078 20.5 3.60078C20.5 4.15078 20.3083 4.61745 19.925 5.00078L17.45 7.47578Z",
    fill: "#0D6CBF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/edit-blue.ae01160b092d3a5997070bc34a32c407.svg";
export { ForwardRef as ReactComponent };